import Pageheader from 'components/Pageheader';
import ModalContext from 'contexts/ModalContext';
import React, { useEffect, useState, useContext, useRef } from 'react';
import { Helmet } from "react-helmet";
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { GetRestaurant, GetRestaurantBranch } from 'services/Api/Module/Restaurant';
import { GetAddress } from 'services/Api/Module/address';
import useBookingPage from 'services/store/BookingPage';
import helper from 'services/helper';
import { SearchCustomer } from 'services/Api/Module/Customer';
import ModalMemberExist from 'components/modal/ModalMemberExist';
import moment from 'moment';
import 'moment/locale/th';
import useTranslations from 'i18n/useTranslations';

const maxDate = moment().add(-16, "year").format("YYYY-MM-DD"); // 10 ปีที่แล้ว

const Register = () => {
    let [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const qPage = searchParams.get("page")
    const { register, setRegister } = useBookingPage();
    const { t, lang } = useTranslations();
    const { mAlert } = useContext(ModalContext);
    const [restaurant, setRestaurant] = useState([]);
    const [selectedRestaurant, setSelectedRestaurant] = useState(register?.restaurant || "");
    const [firstName, setFirstName] = useState(register?.firstName || "");
    const [lastName, setLastName] = useState(register?.lastName || "");
    const [birthday, setBirthday] = useState(register?.birthday || "");
    const [gender, setGender] = useState(register?.gender || null);
    const [contactNumber, setContactNumber] = useState(register?.contactNumber || "");
    const [email, setEmail] = useState(register?.email || "");
    const [pdpa, setPdpa] = useState(register?.pdpa || 0);
    const [marketing, setMarketing] = useState(register?.marketing || 0);
    const [address, setAddress] = useState(register?.address || "");
    const [province, setProvince] = useState([]);
    const [allDistrict, setAllDistrict] = useState([]);
    const [allSubDistrict, setAllSubDistrict] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState(register?.province || "");
    const [selectedDistrict, setSelectedDistrict] = useState(register?.district || "");
    const [selectedSubDistrict, setSelectedSubDistrict] = useState(register?.subDistrict || "");
    const [restaurantBranch, setRestaurantBranch] = useState([]);
    const [selectedRestaurantBranch, setSelectedRestaurantBranch] = useState(register?.branch || null);
    const [postCode, setPostCode] = useState(register?.postCode || "");
    const [isFormComplete, setIsFormComplete] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isContactNumberValid, setIsContactNumberValid] = useState(true);
    const [isBirthdayValid, setIsBirthdayValid] = useState(true);
    const [hasBranch, setHasBranch] = useState(register?.hasBranch || 0);
    const calendarRef = useRef(null);

    const handleOnClick = () => {
        navigate("/" + window.location.search);
    };
    const handleOk = () => {
        setIsOpenModal(false);
    }
    const handlePolicy = () => {
        setRegister({
            firstName: firstName,
            lastName: lastName,
            birthday: birthday,
            gender: gender,
            contactNumber: contactNumber,
            email: email,
            restaurant: selectedRestaurant,
            branch: selectedRestaurantBranch,
            province: selectedProvince,
            district: selectedDistrict,
            subDistrict: selectedSubDistrict,
            pdpa: pdpa,
            postCode: postCode,
            marketing: marketing,
            address: address,
            hasBranch: hasBranch
        })
        if (lang == 'th') {
            navigate('/policy-th' + window.location.search, { state: { from: 'register' } });
        } else {
            navigate('/policy-en' + window.location.search, { state: { from: 'register' } });
        }
    }
    const handleNext = () => {
        setRegister({
            firstName: firstName,
            lastName: lastName,
            birthday: birthday,
            gender: gender,
            contactNumber: contactNumber,
            email: email,
            restaurant: selectedRestaurant,
            branch: selectedRestaurantBranch,
            province: selectedProvince,
            district: selectedDistrict,
            subDistrict: selectedSubDistrict,
            pdpa: pdpa,
            postCode: postCode,
            marketing: marketing,
            address: address,
            hasBranch: hasBranch
        })
        if (qPage) {

            navigate('/register-otp' + window.location.search)
        } else {

            navigate('/register-otp')
        }
    };

    const fetchGetAddress = async () => {
        try {
            const response = await GetAddress();
            const resData = response?.data;
            if (resData.resultCode == "20000") {
                setProvince(resData.resultData.province);
                setAllDistrict(resData.resultData.district);
                setAllSubDistrict(resData.resultData.subDistrict);
            } else {
                mAlert.info({
                    title: t.register.popup.notification,
                    subTitle: t.register.popup.wrong,
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: t.register.popup.notification,
                subTitle: t.register.popup.wrong,
                content: "",
                onClose: () => { },
            });
        }
    };

    const fetchGetRestaurant = async () => {
        try {
            const response = await GetRestaurant();
            const resData = response?.data;
            if (resData?.resultCode == "20000") {
                let remainingBrand = resData.resultData.filter(item => item.id != 21);
                setRestaurant(remainingBrand);
            } else {
                mAlert.info({
                    title: t.register.popup.notification,
                    subTitle: t.register.popup.wrong,
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: t.register.popup.notification,
                subTitle: t.register.popup.wrong,
                content: "",
                onClose: () => { },
            });
        }
    };

    const fetchGetRestaurantBranch = async (payload) => {
        try {
            const response = await GetRestaurantBranch({ params: payload });
            const resData = response?.data;
            if (resData?.resultCode == "20000") {
                setRestaurantBranch(resData?.resultData);

                // ถ้าไม่มีสาขาจะเลือก สาขาแรกมาเอง
                if (resData?.resultData.length) {
                    const _restBranchId = resData?.resultData[0]?.id ?? null
                    if (hasBranch == 1) {
                        // setSelectedRestaurantBranch("")
                    } else {
                        setSelectedRestaurantBranch(_restBranchId)
                    }
                }
            } else {
                mAlert.info({
                    title: "ไม่พบเบอร์มือถือ",
                    subTitle: "เบอร์มือถือนี้ไม่ตรงกับเบอร์ในระบบ",
                    content: "",
                    onClose: () => { },
                });
            }
        } catch (err) {
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };

    useEffect(() => {
        if (firstName && lastName && birthday && isBirthdayValid && contactNumber.length === 10 && isContactNumberValid && email && pdpa) {
            setIsFormComplete(true);
        } else {
            setIsFormComplete(false);
        }
        console.log(isFormComplete)
    }, [firstName, lastName, birthday, contactNumber, email, pdpa]);

    useEffect(() => {
        fetchGetRestaurant();
        fetchGetAddress();
        console.log()
    }, []);

    useEffect(() => {
        if (selectedRestaurant) {
            let payload = {
                restaurant: selectedRestaurant
            };
            fetchGetRestaurantBranch(payload);
        }
    }, [selectedRestaurant]);

    const handleProvinceChange = (e) => {
        const provinceId = e.target.value;
        setSelectedProvince(provinceId);
        setSelectedDistrict("");
        setSelectedSubDistrict("");
        setPostCode("");
    };

    const handleDistrictChange = (e) => {
        const districtId = e.target.value;
        setSelectedDistrict(districtId);
        setSelectedSubDistrict("");
        setPostCode("");
    };

    const handleSubDistrictChange = (e) => {
        const subDistrictId = e.target.value;
        setSelectedSubDistrict(subDistrictId);
        const selectedSub = allSubDistrict.find(sub => sub.id == subDistrictId);
        setPostCode(selectedSub ? selectedSub.postCode : "");
    };

    const handlePdpa = (e) => {
        setPdpa(e.target.checked ? 1 : 0);
    };

    const handleMarketing = (e) => {
        setMarketing(e.target.checked ? 1 : 0);
    };

    const handleDateChange = (e) => {
        const selectedDate = e;
        setBirthday(selectedDate);
    };

    const calculateMaxDate = () => {
        const maxDate = moment().subtract(16, "years").format("YYYY-MM-DD");
        return maxDate;
    };

    const handleGenderChange = (e) => {
        setGender(e.target.value);
    };

    const handleContactNumber = async (e) => {
        const value = e.target.value;
        setContactNumber(value);

        if (value.length === 10) {
            const response = await SearchCustomer({ params: { contactNumber: value } });
            const resData = response?.data;
            if (resData?.resultCode != 20204) {
                setIsContactNumberValid(false);
                setIsFormComplete(false);
            } else {
                setIsContactNumberValid(true);
                setIsFormComplete(firstName && lastName && birthday && email && pdpa);
            }
        } else {
            setIsContactNumberValid(true);
            setIsFormComplete(false);
        }
    };


    const handleEmail = (e) => {
        setEmail(e.target.value);
    };

    const handleAddress = (e) => {
        setAddress(e.target.value);
    };
    console.log('birthday >>', birthday)
    return (
        <div>
            <Helmet>
                <title>IMPACT Family</title>
                <meta name="title" content="Impact Family" />
                <meta name="description" content="Impact Family" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="Impact Family" />
                <meta property="og:description" content="Impact Family" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Impact Family" />
            </Helmet>
            <div id="pageRegister-form">
                <Pageheader pagename={t.register.register} onClick={handleOnClick} />
                <main id="top">
                    <div className="wrapContent">
                        <section id="pRegister">
                            <div className="bRegisterMain">
                                <form>
                                    <div className="bForm">
                                        <div className="bGroup">
                                            <div className="bRow">
                                                <div className="control-group validate">
                                                    <div className="inputPlaceholder">
                                                        <span>{t.register.firstName}</span>
                                                        <input type="text" name="text" placeholder={t.register.firstName} value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                                    </div>
                                                    <label htmlFor="" className="tError">Text Error Input</label>
                                                </div>
                                            </div>
                                            <div className="bRow">
                                                <div className="control-group validate">
                                                    <div className="inputPlaceholder">
                                                        <span>{t.register.lastName}</span>
                                                        <input type="text" name="text" placeholder={t.register.lastName} value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                                    </div>
                                                    <label htmlFor="" className="tError">Text Error Input</label>
                                                </div>
                                            </div>
                                            <div className="bRow">
                                                <div className={`control-group validate ${!isBirthdayValid ? 'error' : ''}`}>
                                                    <div class="tTitle">{t.register.birthday}</div>
                                                    <input
                                                        placeholder="Date"
                                                        type="date"
                                                        className="inputDate"
                                                        onFocus={(e) => e.target.type = 'date'}
                                                        value={birthday ? moment(birthday).format('YYYY-MM-DD') : ""}
                                                        onChange={(e) => {
                                                            console.log('e >>', e.target.value)
                                                            const value = e.target.value

                                                            if (moment(value).format("YYYY-MM-DD") > maxDate) {
                                                                handleDateChange(value)
                                                                setIsBirthdayValid(false)
                                                            } else {
                                                                handleDateChange(value)
                                                                setIsBirthdayValid(true)
                                                            }
                                                        }}
                                                        max={maxDate}
                                                    />
                                                    <label htmlFor="" className="tError">ผู้ลงทะเบียนต้องมีอายุไม่ต่ำกว่า 16 ปี</label>
                                                </div>
                                            </div>
                                            <div className="bRow">
                                                <div className="control-group">
                                                    <div className="tTitle">{t.register.gender}</div>
                                                    <div className="gender">
                                                        <label className="control control--radio">{t.register.male}
                                                            <input type="radio" name="radio" checked={gender == 0} onChange={handleGenderChange} value="0" />
                                                            <div className="control__indicator"></div>
                                                        </label>
                                                        <label className="control control--radio">{t.register.female}
                                                            <input type="radio" name="radio" checked={gender == 1} onChange={handleGenderChange} value="1" />
                                                            <div className="control__indicator"></div>
                                                        </label>
                                                        <label className="control control--radio">{t.register.neutral}
                                                            <input type="radio" name="radio" checked={gender == 2} onChange={handleGenderChange} value="2" />
                                                            <div className="control__indicator"></div>
                                                        </label>
                                                    </div>
                                                    <label htmlFor="" className="tError">Text Error Input</label>
                                                </div>
                                            </div>
                                            <div className="bRow">
                                                <div className={`control-group validate ${!isContactNumberValid ? 'error' : ''}`}>
                                                    <div className="inputPlaceholder">
                                                        <span>{t.register.phoneNumber}</span>
                                                        <input type="text" inputMode="numeric" name="" placeholder="เบอร์มือถือ" value={contactNumber} onChange={handleContactNumber} onInput={helper.FNFORM.handleNumberOnly} maxLength={10} />
                                                    </div>
                                                    <label htmlFor="" className="tError">{t.register.alreadyUsed}</label>
                                                </div>
                                            </div>
                                            <div className="bRow">
                                                <div className="control-group validate">
                                                    <div className="inputPlaceholder">
                                                        <span>{t.register.email}</span>
                                                        <input type="text" name="text" placeholder="อีเมล" value={email} onChange={handleEmail} />
                                                    </div>
                                                    <label htmlFor="" className="tError">Text Error Input</label>
                                                </div>
                                            </div>
                                            <div className="bRow">
                                                <div className="control-group">
                                                    <div className="select">
                                                        <select
                                                            value={selectedRestaurant}
                                                            onChange={(e) => {
                                                                setSelectedRestaurant(e.target.value)
                                                                const _hasBranch = restaurant.find(item => item.id == e.target.value)?.hasBranch ?? 0
                                                                setHasBranch(_hasBranch)
                                                                setSelectedRestaurantBranch("")
                                                            }}
                                                        >
                                                            <option value="">{t.register.restaurant}</option>
                                                            {restaurant?.map((rest, index) => (
                                                                <option key={index} value={rest.id}>{rest.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <label htmlFor="" className="tError">Text Error Input</label>
                                                </div>
                                            </div>
                                            {
                                                hasBranch == 1
                                                    ? (
                                                        <div className="bRow">
                                                            <div className="control-group">
                                                                <div className="select">
                                                                    <select
                                                                        value={selectedRestaurantBranch}
                                                                        onChange={(e) => setSelectedRestaurantBranch(e.target.value)}
                                                                    >
                                                                        <option value="">{t.register.branch}</option>
                                                                        {restaurantBranch?.map((branch, index) => (
                                                                            <option key={index} value={branch.id}>{branch.name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <label htmlFor="" className="tError">Text Error Input</label>
                                                            </div>
                                                        </div>
                                                    )
                                                    : <></>
                                            }

                                            <div className="bRow">
                                                <div className="control-group">
                                                    <div className="tTitle">{t.register.address}</div>
                                                    <input type="text" name="text" placeholder={t.register.addressInfo} value={address} onChange={handleAddress} />
                                                    <label htmlFor="" className="tError">Text Error Input</label>
                                                </div>
                                            </div>
                                            <div className="bRow">
                                                <div className="control-group">
                                                    <div className="select">
                                                        <select value={selectedProvince} onChange={handleProvinceChange}>
                                                            <option>{t.register.province}</option>
                                                            {province?.map((prov, index) => (
                                                                <option key={index} value={prov.id}>{prov.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <label htmlFor="" className="tError">Text Error Input</label>
                                                </div>
                                            </div>
                                            <div className="bRow">
                                                <div className="control-group">
                                                    <div className="select">
                                                        <select value={selectedDistrict} onChange={handleDistrictChange}>
                                                            <option>{t.register.district}</option>
                                                            {allDistrict?.filter(sub => sub.provinceId == selectedProvince).map((dist, index) => (
                                                                <option key={index} value={dist.id}>{dist.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <label htmlFor="" className="tError">Text Error Input</label>
                                                </div>
                                                <div className="control-group">
                                                    <div className="select">
                                                        <select value={selectedSubDistrict} onChange={handleSubDistrictChange}>
                                                            <option>{t.register.subDistrict}</option>
                                                            {allSubDistrict?.filter(sub => sub.districtId == selectedDistrict).map((sub, index) => (
                                                                <option key={index} value={sub.id}>{sub.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <label htmlFor="" className="tError">Text Error Input</label>
                                                </div>
                                            </div>
                                            <div className="bRow">
                                                <div className="control-group">
                                                    <input type="text" name="text" placeholder={t.register.zipcode} value={postCode} disabled />
                                                    <label htmlFor="" className="tError">Text Error Input</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bPdpa">
                                            <div className="bRow">
                                                <div className="control-group pdpa">
                                                    <label className="control control--checkbox">
                                                        <p>
                                                            {t.register.agree} <a onClick={handlePolicy}>{t.register.pdpa}</a>
                                                        </p>
                                                        <input type="checkbox" onChange={handlePdpa} checked={pdpa == 1} />
                                                        <div className="control__indicator"></div>
                                                    </label>
                                                    <label htmlFor="" className="tError">จำเป็นต้องยินยอมรับข้อตกลงและเงื่อนไขและนโยบายความเป็นส่วนตัว</label>
                                                </div>
                                            </div>
                                            <div className="bRow">
                                                <div className="control-group pdpa">
                                                    <label className="control control--checkbox">
                                                        <p>
                                                            {t.register.agree} {t.register.marketing}<a href="policy-privacy.php"></a>
                                                        </p>
                                                        <input type="checkbox" onChange={handleMarketing} checked={marketing == 1} />
                                                        <div className="control__indicator"></div>
                                                    </label>
                                                    <label htmlFor="" className="tError">จำเป็นต้องยินยอมวัตถุประสงค์ทางการตลาด</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bBtn">
                                            <button className="btn" onClick={handleNext} disabled={!isFormComplete} type="button">{t.register.next}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </section>
                    </div>
                </main>
                <ModalMemberExist onClose={handleOk} open={isOpenModal} />
            </div>
        </div>
    );
};

export default Register;
